/* eslint-disable @typescript-eslint/no-explicit-any */

import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

type ServiciosSchedulerResponse = {
  state: number;
  value: any;
};

export const serviciosScheduler = async (): Promise<any> => {
  try {
    const res = await apiClient.post<ServiciosSchedulerResponse>(
      Endpoints.ServiciosScheduler,
      {}
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
